import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminDomainsNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('domain');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
